import { Component, Mixins, Prop, Ref, Vue, Watch } from 'vue-property-decorator'
import DiagramService from '@/app/services/diagram-data-service'
import * as htmlToImage from 'html-to-image'
import saveAs from 'file-saver'
import { diagramViews, DiagramType, DiagramView } from '@/diagrams/models/diagram-views'
import Visual from '@/diagrams/models/visual'

@Component
export default class Matrix extends Vue implements Visual {

    @Ref()
    private matrix: any

    private chunkSize = 15

    private title: string = ''
    private rowNames: any[] = []
    private colNames: any[] = []
    private relations: boolean[][] = []
    private chunks: any[] = []
    private loaded = false

    private action: string = diagramViews.items.find((i) => i.type === DiagramType.Matrix)!.url

    public async setActionAsync(ctx: DiagramView) {
        this.action = ctx.url
        this.title = ctx.name.replace('Matrix - ', '')
        await this.fetchDataAsync()
    }

    public async saveAsync(format: string) {
        // NOTE: Kein SVG Modus möglich.
        const b64 = await htmlToImage.toPng(this.matrix)
        saveAs(b64, 'matrix.png')
    }

    private async fetchDataAsync() {
        const id = this.$route.params.projectId
        const data: any = await DiagramService.matrix(id, this.action)

        this.rowNames = []
        this.colNames = []
        this.relations = []

        for (const item of data) {
            if (!this.colNames.find((s) => s.columnId === item.columnId)) {
                this.colNames.push({
                    columnId: item.columnId,
                    columnName: this.truncate(item.columnName),
                    backgroundColor: item.columnBias === 0 ? null : (item.columnBias > 0 ? 'rgba(172,185,164,0.5)' : 'rgba(211,175,165,0.5)'),
                })
            }
            if (this.rowNames.filter((s) => s.rowId === item.rowId).length === 0) {
                this.rowNames.push({
                    rowId: item.rowId,
                    rowName: item.rowName,
                    backgroundColor: item.rowBias === 0 ? null : (item.rowBias > 0 ? 'rgba(172,185,164,0.5)' : 'rgba(211,175,165,0.5)'),
                })
            }
        }

        for (const row of this.rowNames) {
            const relRow = []
            for (const col of this.colNames) {
                const hasRel = data
                    .find((d: any) =>
                        d.rowId === row.rowId
                        && d.columnId === col.columnId)
                    .hasRelation
                relRow.push(hasRel)
            }
            this.relations.push(relRow)
        }

        this.chunks = this.chunkIndices(this.colNames.length, this.chunkSize)
    }

    private chunkIndices(collSize: number, chunkSize: number) {
        const chunks = []
        for (let i = 0; i < collSize; i += chunkSize) {
            chunks.push({
                start: i,
                end: Math.min(i + chunkSize, collSize),
            })
        }
        return chunks
    }

    private truncate(input: string) {
        const limit = 30
        if (input && input.length > limit) {
            return input.substring(0, limit - 3) + '...'
        }
        return input
    };

    private async mounted() {
        this.loaded = false
        await this.fetchDataAsync()
        this.loaded = true
    }
}
